(function () {
  'use strict';

  /*
   * Japan2UK Card Reference Search V4
   *
   * Predictive search is used as the source of truth for searches such as:
   *
   * 014/025
   * 014 025
   * 014-025
   *
   * Normal text searches continue to use the standard Shopify search page.
   *
   * V4:
   * Predictive single-card results now include show-actions--mobile so their
   * Buy Now, Add To Cart, Choose Options, Notify Me and Sold Out actions are
   * displayed on mobile as well as desktop.
   */

  var SELECTORS = {
    resultsContainer: '[data-j2uk-card-reference-results]',
    standardProductGrid: '.productgrid--items:not(.j2uk-card-reference-grid)',
    noResults: '.productgrid--no-results',
    pagination: '.pagination'
  };

  var currentQuery = getSearchQuery();
  var currentReference = parseCardReference(currentQuery);

  /*
   * Add the state immediately, before DOMContentLoaded.
   * This reduces the flash of Shopify's standard search results.
   */
  if (currentReference) {
    document.documentElement.classList.add(
      'j2uk-card-reference-search-pending'
    );

    injectPendingStyles();
  }

  function parseCardReference(value) {
    var match = String(value || '')
      .trim()
      .match(/^(\d{1,4})\s*(?:\/|-|\s)\s*(\d{1,4})$/);

    if (!match) {
      return null;
    }

    return {
      left: match[1],
      right: match[2],
      slash: match[1] + '/' + match[2],
      spaced: match[1] + ' ' + match[2]
    };
  }

  function getSearchQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('q') || '';
    } catch (error) {
      return '';
    }
  }

  function injectPendingStyles() {
    if (document.getElementById('j2uk-card-reference-search-style')) {
      return;
    }

    var style = document.createElement('style');

    style.id = 'j2uk-card-reference-search-style';

    style.textContent =
      'html.j2uk-card-reference-search-pending ' +
      '.productgrid--items:not(.j2uk-card-reference-grid),' +
      'html.j2uk-card-reference-search-pending ' +
      '.productgrid--no-results,' +
      'html.j2uk-card-reference-search-pending ' +
      '.pagination {' +
        'visibility: hidden !important;' +
      '}' +

      'html.j2uk-card-reference-search-active ' +
      '.productgrid--items:not(.j2uk-card-reference-grid),' +
      'html.j2uk-card-reference-search-active ' +
      '.productgrid--no-results,' +
      'html.j2uk-card-reference-search-active ' +
      '.pagination {' +
        'display: none !important;' +
      '}' +

      '.j2uk-card-reference-results[hidden] {' +
        'display: none !important;' +
      '}' +

      '.j2uk-card-reference-grid {' +
        'visibility: visible !important;' +
      '}';

    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normaliseTitle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(
        /(\d{1,4})\s*\/\s*(\d{1,4})/g,
        '$1/$2'
      )
      .trim();
  }

  function titleContainsReference(title, reference) {
    return (
      normaliseTitle(title)
        .indexOf(reference.slash.toLowerCase()) !== -1
    );
  }

  function fetchPredictiveProducts(query) {
    var endpoint =
      '/search/suggest.json' +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=show';

    return fetch(endpoint, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Predictive search failed: ' + response.status
          );
        }

        return response.json();
      })
      .then(function (payload) {
        if (
          !payload ||
          !payload.resources ||
          !payload.resources.results ||
          !Array.isArray(
            payload.resources.results.products
          )
        ) {
          return [];
        }

        return payload.resources.results.products;
      });
  }

  function cleanProductUrl(url) {
    if (!url) {
      return '';
    }

    try {
      var parsed = new URL(url, window.location.origin);

      return parsed.pathname;
    } catch (error) {
      return String(url)
        .split('?')[0]
        .split('#')[0];
    }
  }

  function fetchFullProduct(product) {
    var productUrl = cleanProductUrl(product.url);

    if (!productUrl) {
      return Promise.resolve(null);
    }

    return fetch(productUrl + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Product request failed: ' + response.status
          );
        }

        return response.json();
      })
      .then(function (fullProduct) {
        fullProduct._j2ukProductUrl = productUrl;

        return fullProduct;
      })
      .catch(function (error) {
        console.warn(
          '[Japan2UK Card Reference Search] ' +
          'Could not load full product:',
          productUrl,
          error
        );

        return null;
      });
  }

  function getFeaturedImage(product) {
    if (!product) {
      return '';
    }

    if (product.featured_image) {
      return product.featured_image;
    }

    if (
      Array.isArray(product.images) &&
      product.images.length
    ) {
      return product.images[0];
    }

    return '';
  }

  function formatMoney(cents) {
    var value = Number(cents);

    if (isNaN(value)) {
      return '';
    }

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(value / 100);
  }

  function getAvailableVariants(product) {
    if (
      !product ||
      !Array.isArray(product.variants)
    ) {
      return [];
    }

    return product.variants.filter(function (variant) {
      return variant.available;
    });
  }

  function productIsAvailable(product) {
    return getAvailableVariants(product).length > 0;
  }

  function hasSinglePurchasableVariant(product) {
    var variants = getAvailableVariants(product);

    return variants.length === 1;
  }

  function getSinglePurchasableVariant(product) {
    var variants = getAvailableVariants(product);

    if (variants.length !== 1) {
      return null;
    }

    return variants[0];
  }

  function buildProductCard(product) {
    var item = document.createElement('div');

    /*
     * show-actions--mobile is deliberately scoped to cards created by this
     * predictive card-reference script. Standard Shopify search results are
     * not modified.
     */
    item.className =
      'productgrid--item ' +
      'j2uk-japanese-single-card ' +
      'show-actions--mobile';

    item.setAttribute('data-product-item', '');

    item.setAttribute(
      'data-product-quickshop-url',
      product._j2ukProductUrl || '/products/' + product.handle
    );

    item.setAttribute(
      'data-available',
      String(productIsAvailable(product))
    );

    var url =
      product._j2ukProductUrl ||
      '/products/' + product.handle;

    var title =
      product.title ||
      'Product';

    var imageUrl =
      getFeaturedImage(product);

    var available =
      productIsAvailable(product);

    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    var hasVariants =
      variants.length > 1;

    var selectedVariant =
      variants.find(function (variant) {
        return variant.available;
      }) ||
      variants[0] ||
      null;

    var displayedPrice =
      selectedVariant
        ? formatMoney(selectedVariant.price)
        : '';

    var actionMarkup = '';

    if (available) {
      actionMarkup =
        '<div class="productitem--actions" data-product-actions>' +

          '<div class="productitem--action quickshop-button">' +

            '<a' +
              ' class="productitem--action-trigger button-secondary"' +
              ' href="' + escapeHtml(url) + '"' +
            '>' +
              'Buy Now' +
            '</a>' +

          '</div>' +

          '<div class="productitem--action atc--button">' +

            (
              hasVariants
                ? '<a' +
                    ' class="productitem--action-trigger productitem--action-atc button-primary"' +
                    ' href="' + escapeHtml(url) + '"' +
                  '>' +
                    '<span class="atc-button--text">' +
                      'Choose Options' +
                    '</span>' +
                  '</a>'

                : '<button' +
                    ' class="productitem--action-trigger productitem--action-atc button-primary"' +
                    ' type="button"' +
                    ' data-j2uk-add-to-cart' +
                    ' data-variant-id="' +
                      escapeHtml(
                        selectedVariant
                          ? selectedVariant.id
                          : ''
                      ) +
                    '"' +
                  '>' +

                    '<span class="atc-button--text">' +
                      'Add To Cart' +
                    '</span>' +

                  '</button>'
            ) +

          '</div>' +

        '</div>';
    } else {
      actionMarkup =
        '<div class="productitem--actions" data-product-actions>' +

          '<div class="productitem--action quickshop-button">' +

            '<a' +
              ' class="productitem--action-trigger button-secondary j2uk-notify-me"' +
              ' href="' +
                escapeHtml(url) +
                '?open-restock=1"' +
              ' aria-label="Notify Me"' +
            '>' +
              'Notify Me' +
            '</a>' +

          '</div>' +

          '<div class="productitem--action atc--button">' +

            '<button' +
              ' class="productitem--action-trigger productitem--action-atc button-primary disabled"' +
              ' type="button"' +
              ' aria-label="Sold Out"' +
              ' disabled' +
            '>' +

              '<span class="atc-button--text">' +
                'Sold Out' +
              '</span>' +

            '</button>' +

          '</div>' +

        '</div>';
    }

    item.innerHTML =
      '<div class="productitem" data-product-item-content>' +

        '<div class="productitem__container">' +

          '<div class="productitem__image-container">' +

            '<a' +
              ' class="productitem--image-link"' +
              ' href="' + escapeHtml(url) + '"' +
              ' tabindex="-1"' +
              ' data-product-page-link' +
            '>' +

              '<figure' +
                ' class="productitem--image"' +
                ' data-product-item-image' +
              '>' +

                (
                  imageUrl
                    ? '<img' +
                        ' class="productitem--image-primary"' +
                        ' src="' + escapeHtml(imageUrl) + '"' +
                        ' alt="' + escapeHtml(title) + '"' +
                        ' loading="lazy"' +
                      '>'
                    : ''
                ) +

                (
                  available
                    ? ''
                    : '<span' +
                        ' class="productitem__badge productitem__badge--soldout j2uk-standard-soldout-badge"' +
                        ' style="' +
                          'display:inline-flex !important;' +
                          'visibility:visible !important;' +
                          'opacity:1 !important;' +
                          'background-color:#C14238 !important;' +
                          'border-color:#C14238 !important;' +
                          'color:#FFFFFF !important;' +
                        '"' +
                      '>' +
                        'Sold Out' +
                      '</span>'
                ) +

                '<span class="visually-hidden">' +
                  escapeHtml(title) +
                '</span>' +

              '</figure>' +

            '</a>' +

          '</div>' +

          '<div class="productitem--info">' +

            '<h2 class="productitem--title">' +

              '<a' +
                ' href="' + escapeHtml(url) + '"' +
                ' data-product-page-link' +
              '>' +
                escapeHtml(title) +
              '</a>' +

            '</h2>' +

            (
              displayedPrice
                ? '<div class="productitem--price">' +
                    escapeHtml(displayedPrice) +
                  '</div>'
                : ''
            ) +

          '</div>' +

          actionMarkup +

        '</div>' +

      '</div>';

    return item;
  }

  function hideStandardResults() {
    document.documentElement.classList.remove(
      'j2uk-card-reference-search-pending'
    );

    document.documentElement.classList.add(
      'j2uk-card-reference-search-active'
    );
  }

  function restoreStandardResults() {
    document.documentElement.classList.remove(
      'j2uk-card-reference-search-pending'
    );

    document.documentElement.classList.remove(
      'j2uk-card-reference-search-active'
    );
  }

  function renderProducts(container, products) {
    if (!products.length) {
      restoreStandardResults();
      return;
    }

    var productsPerRow =
      container.getAttribute(
        'data-products-per-row'
      ) || '4';

    var grid =
      document.createElement('div');

    grid.className =
      'productgrid--items ' +
      'products-per-row-' +
      productsPerRow +
      ' j2uk-card-reference-grid';

    products.forEach(function (product) {
      grid.appendChild(
        buildProductCard(product)
      );
    });

    container.innerHTML = '';
    container.appendChild(grid);
    container.hidden = false;

    hideStandardResults();
  }

  function addToCart(button) {
    var variantId =
      button.getAttribute(
        'data-variant-id'
      );

    if (!variantId) {
      return;
    }

    var originalText =
      button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response
            .json()
            .then(function (error) {
              throw error;
            });
        }

        return response.json();
      })
      .then(function () {
        button.textContent = 'Added To Cart';

        document.dispatchEvent(
          new CustomEvent(
            'j2uk:card-reference-added-to-cart',
            {
              bubbles: true,
              detail: {
                variantId: variantId
              }
            }
          )
        );

        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 1800);
      })
      .catch(function (error) {
        console.warn(
          '[Japan2UK Card Reference Search] ' +
          'Add to cart failed:',
          error
        );

        button.disabled = false;
        button.textContent = originalText;
      });
  }

  function bindCartButtons(container) {
    container.addEventListener(
      'click',
      function (event) {
        var button =
          event.target.closest(
            '[data-j2uk-add-to-cart]'
          );

        if (!button) {
          return;
        }

        event.preventDefault();

        addToCart(button);
      }
    );
  }

  function init() {
    var container =
      document.querySelector(
        SELECTORS.resultsContainer
      );

    if (!container) {
      restoreStandardResults();
      return;
    }

    if (!currentReference) {
      restoreStandardResults();
      return;
    }

    container.setAttribute(
      'data-j2uk-card-reference-query',
      currentReference.slash
    );

    bindCartButtons(container);

    fetchPredictiveProducts(
      currentReference.spaced
    )
      .then(function (predictiveProducts) {
        var exactMatches =
          predictiveProducts.filter(
            function (product) {
              return titleContainsReference(
                product.title,
                currentReference
              );
            }
          );

        if (!exactMatches.length) {
          restoreStandardResults();
          return [];
        }

        return Promise.all(
          exactMatches.map(
            fetchFullProduct
          )
        );
      })
      .then(function (fullProducts) {
        if (!fullProducts) {
          return;
        }

        var validProducts =
          fullProducts.filter(
            function (product) {
              return !!product;
            }
          );

        if (!validProducts.length) {
          restoreStandardResults();
          return;
        }

        renderProducts(
          container,
          validProducts
        );
      })
      .catch(function (error) {
        console.warn(
          '[Japan2UK Card Reference Search]',
          error
        );

        restoreStandardResults();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();